import React from "react";
import { useContext, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import AuthContext from '../store/AuthContext';
import DimensionsService from "../services/DimensionsService"
import DimensionInfo from "../models/DimensionInfo"
import OwnDimensionItem from "../components/OwnDimensionItem"
import AccountService from "../services/AccountService"
import {Button} from 'react-bootstrap';
import {BsFillPlusCircleFill} from 'react-icons/bs';

const OwnDimensionsPage: React.FC = () => {
    const authCtx = useContext(AuthContext);
    let navigate = useNavigate();
    const [dimensions, setDimensions] = useState<DimensionInfo[]>([]);

    useEffect(() => {
        document.title=`DimensionX Studio | Your Dimensions`;

        let ids = authCtx.account.getEditableDimensions();
        if (ids.length == 0) {
            setDimensions([]);
            return;
        }
        DimensionsService.listDimensions({ids: ids, env: 'dev'})
            .then((data: DimensionInfo[]) => {setDimensions(data)})
            .catch(error => console.error(`List own dimensions error: ${error}`));
    }, [authCtx]);

    function createNewDimension() {
        if (Object.keys(authCtx.account.dimensions).length >= authCtx.account.studio.maxDimensions) {
            alert(`You have reached the maximum nuber of dimensions: ${authCtx.account.studio.maxDimensions}`);
            return;
        }

        let name = prompt("Enter dimension name");
        if (!name) {
            return;
        }
        DimensionsService.createDimension(name)
        .then((data: DimensionInfo)=>{
            AccountService.reloadCurrentAccount()
        })
        .catch((error: string)=>{ console.error(`Failed to create new dimension: ${error}`)});
    }

    if (!authCtx.account.studio.enabled) {
        return (<>
                    <h4>Please contact our team to get access to Creative Studio.</h4>
                    <h4>Email: info@dimx.world</h4>
                </>);
    }

    return (
        <div>
            <Button variant="primary" onClick={createNewDimension} style={{ marginBottom: 'var(--margin-half)' }} >
                <span style={{ display: 'flex', alignItems: 'center' }}>
                    <BsFillPlusCircleFill size={24} style={{ marginRight: '8px' }} />
                    Create New Dimension
                </span>
            </Button>

            <div className="d-flex flex-column">
                {dimensions.map((item, index)=>{
                    return (
                        <div style={{ marginBottom: 'var(--margin-half)' }} key={index}>
                            <OwnDimensionItem key={index} data={item}/>
                        </div>
                    );
                })}
            </div>
        </div>
    );
};

export default OwnDimensionsPage;
